var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.158,
    height: 45.021,
    viewBox: "0 0 32.158 45.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paper_texture_background_cardboard_pattern_page_blank_white_letter_canvas",
    "data-name": "paper, texture, background, cardboard, pattern, page, blank, white, letter, canvas",
    transform: "translate(-6 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M38.158,16.471a1.608,1.608,0,0,0-.45-1.142L24.844,2.466A1.608,1.608,0,0,0,23.687,2H10.824A4.824,4.824,0,0,0,6,6.824V42.2a4.824,4.824,0,0,0,4.824,4.824h22.51A4.824,4.824,0,0,0,38.158,42.2ZM25.295,7.483l7.38,7.38H26.9a1.608,1.608,0,0,1-1.608-1.608ZM33.334,43.8H10.824A1.608,1.608,0,0,1,9.216,42.2V6.824a1.608,1.608,0,0,1,1.608-1.608H22.079v8.039A4.824,4.824,0,0,0,26.9,18.079h8.039V42.2A1.608,1.608,0,0,1,33.334,43.8Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M11.608,17.216h6.432a1.608,1.608,0,1,0,0-3.216H11.608a1.608,1.608,0,0,0,0,3.216Z",
    transform: "translate(2.432 7.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M27.687,18H11.608a1.608,1.608,0,0,0,0,3.216H27.687a1.608,1.608,0,0,0,0-3.216Z",
    transform: "translate(2.432 9.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M27.687,22H11.608a1.608,1.608,0,0,0,0,3.216H27.687a1.608,1.608,0,0,0,0-3.216Z",
    transform: "translate(2.432 12.158)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.2d7764bb1ad6527502b3ed500e43a439.svg";
export { ForwardRef as ReactComponent };